import React from 'react';
import "./footer.css";
import { FiTwitter, FiGithub, FiLinkedin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__container container">
            <a href="https://bakr-portofolio.netlify.app/"><h1 className="footer__title"><span>المطور / </span>ابوبكر حسن 🤍</h1></a>

            <span className="footer__copy"></span>
        </div>
    </footer>
  );
}

export default Footer;